import { http } from './http';
import { togglesSchema } from '../schemas/toggles';
import { useAPI } from '../composables/use-api';

export type TogglesParams = {
  bypassGone?: boolean,
};

export async function fetchToggles(signatureRequestKey: string, params?: TogglesParams) {
  const { getEndpoint } = useAPI(signatureRequestKey);
  const data = await http(getEndpoint('toggle'), { params });

  return togglesSchema.parse(data).toggles;
}
